const getTasks = (tasks, payload) => {
    const taskObj = {curTasks: [], othTasks: []};
        tasks.reduce((acc, task) => {
          if (task.taskId === payload.taskId) {
            acc.curTasks.push(task);
          } else acc.othTasks.push(task);
          return acc;
        }, taskObj);
  
        return taskObj;
  } 
  
  export default (tasks = [], action) => {
    const { type, payload = {} } = action;
    switch (type) {
      case 'PURGE':
        return [];
      case 'FILE_UPLOAD_INITIATED':
        return [{ ...payload, title: payload.name, status: 0, progress: 0 }, ...tasks];
      case 'FILE_UPLOAD_PROGRESS':
        if (tasks.filter(task => task.taskId === payload.taskId).length > 0) {
          return tasks.map(task => (payload.taskId === task.taskId ? { ...task, ...payload } : task));
        } else if (payload.progress > 45) {
          return [payload, ...tasks];
        } else {
          return tasks;
        }
      case 'FILE_CONFIRM_UPLOAD_SUCCESS':
        if (tasks.filter(task => task.taskId === payload.oldId).length > 0) {
          return tasks.map(task => {
            if (task.taskId === payload.oldId || task.taskId === payload.data.task_id) {
              return { ...task, taskId: payload.data.task_id, assetId: payload.data.id };
            }
            return task;
          });
        } else {
          return [{ taskId: payload.data.task_id, assetId: payload.data.id, status: 0, progress: 40 }, ...tasks];
        }
      case 'FILE_CONFIRM_UPLOAD_FAILED':
        return tasks.map(task => {
          if (task.taskId === payload.taskId) {
            return { ...task, ...payload, status: -1 };
          }
          return task;
        });
      case 'FILE_UPLOAD_FAILED':
        return tasks.map(task => {
          if (task.taskId === payload.taskId) {
            return { ...task, ...payload, status: -1 };
          }
          return task;
        });
      case 'GET_FILE_UPLOAD_URL_FAILED':
        return tasks.map(task => {
          if (task.taskId === payload.taskId) {
            return { ...task, ...payload, status: -1 };
          }
          return task;
        });
      case 'CHUNK_UPLOAD_INITIATED':
        const {curTasks, othTasks} = getTasks(tasks, payload);
        if (curTasks.length === 0) {
          return [...othTasks, { ...payload, title: payload.name, status: 0,
                  progress: 0, chunkTasks: [{...payload,
                  title: payload.name, status: 0, progress: 0 }] }];
        } else {
          const isChunkTask = curTasks[0].chunkTasks.some(chunkTask =>
            chunkTask.chunkTaskId === payload.chunkTaskId);
  
          if (isChunkTask) {
            return tasks;
          }
  
          const chunkTasks = [...curTasks[0].chunkTasks, {...payload, title: payload.name, status: 0, progress: 0 }]
          return [...othTasks, {...curTasks[0], chunkTasks}];
        }
      case 'CHUNK_UPLOAD_PROGRESS':
        const { curTasks: currTasks, othTasks: otherTasks } = getTasks(tasks, payload);
        let progressOld = 0;
  
          const chunkTaskList = currTasks[0].chunkTasks.map((chunkTask) => {
            if (payload.chunkTaskId === chunkTask.chunkTaskId) {
              progressOld = progressOld + payload.progress;
              return {...chunkTask, ...payload}
            }
  
            progressOld = progressOld + chunkTask.progress;
            return chunkTask;
          });
      return [...otherTasks, {...currTasks[0], progress: progressOld/chunkTaskList.length, chunkTasks: chunkTaskList}];
      case 'CHUNK_CONFIRM_UPLOAD_FAILED':
      case 'CHUNK_UPLOAD_FAILED':
        const ChunkTasks = tasks[0].chunkTasks.map(chunkTask => {
          if (chunkTask.chunkTaskId === payload.chunkTaskId) {
            return {...chunkTask, ...payload, status: -1 };
          }
          return chunkTask;
        });
        return [{...tasks[0], chunkTasks: ChunkTasks, status: -1 }];
        default:
        return tasks;
    }
  };